<template>
<div class="chapter">
<div class="inner_page">
<p class="p4"><span class="t3">T</span><span class="t4">HERE</span> are a lot of people who have inspired me throughout my life. Among those who directly influenced this book are J.R.R. Tolkien, Terry Pratchett, and the members of Monty Python. If that sounds strange to you, wait until you actually read this thing. I want to thank them. For a kid who didn’t always fit in, they were always there for me, waiting to cheer me up when I needed it.</p>
<p>But this book isn’t dedicated to them. This book is dedicated to my best friend and an integral part of my life, Gus. If it weren’t for Gus, I wouldn’t be an author. Thank you, friend. You are a constant inspiration and know just when to kick my arse to get me writing. This book is for you.</p>
<p class="p6"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004.vue?28f8757a